<template>
  <div class="main">
    <a-spin class="load"
            v-show="loading"/>
    <!--    <div class="top">-->
    <!--      <span class="icon"-->
    <!--            @click="history"><img class="historyImg"-->
    <!--             src="../../../assets/image/08.png"-->
    <!--             alt=""></span>-->
    <!--      <span class="iconText">备课历史</span>-->
    <!--    </div>-->
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item style="font-size: 16px">
          <router-link :to="'/books/writingGuide'">写作指导</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 16px">备课历史</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="content">
      <div class="list">
        <a-list item-layout="vertical"
                size="large"
                :data-source="listData">
          <a-list-item slot="renderItem"
                       key="item.title"
                       class="item"
                       slot-scope="item">
            <a-list-item-meta :description="item.description">
              <div class="title"
                   slot="title">
                <a-row class="rowTitle">
                  <a-col :span="20">
                    <!-- <a-select :default-value="format.viewPermission(item.permission)"
                              style="width:200px;">
                      <a-select-option v-for="(item, index) in selectOpen"
                                       :key="index"
                                       :value="item.value">
                        {{item.value}}
                      </a-select-option>
                    </a-select> -->
                  </a-col>
                  <a-col class="colButton" :span="4" v-if="item.id==null || item.id == '' || item.id=='undefined'">
                    <a-button class="useTo"
                              disabled>使用
                    </a-button>
                  </a-col>
                  <a-col class="colButton" :span="4" v-else>
                    <a-button class="useTo"
                              @click="use(item.id)">使用
                    </a-button>
                  </a-col>
                </a-row>
                <a-row>
                  <p class="guideTitle">{{ item.title }}</p>
                  <p class="guideText"
                     v-if="item.guideContent" v-html="item.guideContent"></p>
                </a-row>
              </div>
            </a-list-item-meta>
            <!-- <p class="contentMes">{{ item.commentContent }}</p> -->
            <div class="class_info">
              <div class="class_fabu">已发布至</div>
              <div class="class_bj">
                <div class="class_banji" v-for="(ite,inde) in item.classList" :key="inde" :title="ite">{{ ite }}</div>
              </div>
              <div class="release_time">{{ format.format(item.createDate) }}</div>
            </div>
          </a-list-item>
        </a-list>
      </div>
      <div style="text-align:center;margin:15px 0px;">
        <a-config-provider>
          <a-pagination :default-current="1" :page-size="pageSize"
                        @change="handleListChange"
                        :total='total'/>
        </a-config-provider>
      </div>
    </div>
  </div>
</template>

<script>
// import HanIcon from 'components/Icon.vue'
import format from '../../../utils/format.js'

export default {
  name: 'WritingHistory',
  data() {
    return {
      format,
      loading: true,
      selectOpen: [{value: '公开', key: '1'}, {value: '私有', key: '2'}, {value: '仅班级可见', key: '3'}],
      pagination: {
        onChange: page => {
        },
        pageSize: 3,
      },
      listData: [],
      total: 0,
      pageSize: 5,
      pageNum: 1,
    }
  },
  components: {},
  created() {

  },
  watch: {
    mlVisible() {

    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    handleListChange(current, pageSize) {
      this.pageNum = current
      this.pageSize = pageSize
      this.getData()
    },
    getData() {
      const param = {
        bookId: localStorage.getItem('syzg-bookId'),
        styleId: localStorage.getItem('styleId'),
        teacherId: this.$getUserInfo().id,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/guide/getTeacherWritingGuideHistory',
        body: param
      }).loading(
          () => (this.loading = true),
          () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.listData = res.resultData.list
          this.total = res.resultData.total
        }
      })
    },
    use(id) {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/guide/useHistoryWritingGuide',
        body: {id: id, teacherId: this.$getUserInfo().id}
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('使用成功')
          this.getData()
        }
      })
    },
    history() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
ul,
li {
  list-style: none;
}

.main {
  position: relative;
  margin-left: -205px;

  .breadcrumb {
    width: 1240px;
    margin: 0 auto;
  }

  .load {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(50%, 50%);
    z-index: 99;
  }

  .top {
    height: 50px;
    background-color: #fff;
    width: 1240px;
    margin: 0 auto;
    position: relative;

    .historyImg {
      width: 8px;
      height: 16px;
      cursor: pointer;
    }

    .icon {
      position: absolute;
      top: 45%;
      margin-top: -7px;
      left: 50px;
    }

    .iconText {
      position: absolute;
      top: 45%;
      margin-top: -10px;
      left: 70px;
      color: #9d9292;
      font-size: 18px;
    }
  }

  .content {
    // min-height: 1200px;
    background: #fff;
    border-radius: 8px;
    width: 1240px;
    margin: 20px auto;
    padding-top: 30px;
    height: calc(100vh - 185px);

    .list{
      overflow-y: auto;
      height: calc(100vh - 275px);
    }

    .rowTitle {
      .colButton {
        text-align: right;

        .useTo {
          width: 80px;
          height: 30px;
          line-height: 30px;
          background: @primary-color;
          border-radius: 4px;
          color: #fff;
        }
      }
    }

    .title {
      min-height: 160px;

      .guideTitle {
        font-family: PingFangSC-Regular;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 34px;
        letter-spacing: 0px;
        color: #040506;
        margin-top: 5px;
      }

      .guideText {
        margin-top: 15px;
        width: 100%;
        height: 100%;
        // background-color: white;
        border-radius: @border-radius-base;
        font-family: PingFangSC-Regular;
        font-size: 20px;
        color: #040506;
        white-space: pre-wrap;
        font-weight: normal;
        font-stretch: normal;
      }
    }


    .item {
      background: #F1F0F0;
      border-radius: 6px;
      padding: 20px;
      margin-left: 20px;
      margin-right: 20px;
      margin-bottom: 20px;
    }

    .name,
    .className,
    .useNum,
    .useTo {
      letter-spacing: 0px;
      color: #9d9292;
      font-size: 14px;
    }

    .className {
      margin-left: 10px;
    }

    .useTo {
      display: inline-block;
      width: 80px;
      height: 30px;
      background-color: @primary-color;
      color: #fff;
      margin-left: 20px;
    }

    .avatar {
      width: 25px;
      height: 25px;
    }

    .prepare-content {
      margin-top: 15px;
      width: 100%;
      height: 100%;
      //  background-color: white;
      border-radius: @border-radius-base;
      font-family: PingFangSC-Regular;
      font-size: 20px;
      color: #040506;
      white-space: pre-wrap;
      font-weight: normal;
      font-stretch: normal;
    }

    .class_info {
      margin-top: 20px;

      .class_fabu {
        margin-top: 5px;
        width: 64px;
        height: 20px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 20px;
        letter-spacing: 0px;
        color: #867d7b;
        float: left;
      }

      .class_bj {
        width: 900px;
        // overflow-x: auto;
        // white-space: nowrap;
        float: left;

        .class_banji {
          display: inline-block;

          margin-left: 20px;
          width: 130px;
          height: 28px;
          line-height: 28px;
          background-color: #a3af9059;
          border-radius: 16px;
          text-align: center;
          color: #a3af90;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }
      }

      .release_time {
        float: right;
        font-size: 16px;
        color: #867d7b;
      }
    }
  }
}

/deep/ .ant-list-pagination {
  text-align: center;
  padding-bottom: 20px;
  margin-bottom: 10px;
  background: #f1f0f0;
}

/deep/ .ant-list-pagination {
  margin-top: 0px;
}

/deep/ .ant-list-vertical .ant-list-item-meta {
  margin-bottom: 0px;
}

/deep/ .ant-list-split .ant-list-item {
  border-bottom: 10px solid #f1f0f0;
  padding: 20px 30px 20px 30px;
  min-height: 300px;
  overflow-y: auto;
}

/deep/ .ant-list-something-after-last-item
.ant-spin-container
> .ant-list-items
> .ant-list-item:last-child {
  border-bottom: 10px solid #f1f0f0;
}

/deep/ .ant-tabs-nav-scroll {
  background: #FFFFFF;
  border-radius: 10px;
}

/deep/ .ant-list-empty-text {
  background: #FFFFFF;
  border-radius: 10px;
}
</style>
